import { listQueue } from "./queue";
import { offlineActions } from "../backend/store/reducers/offlineReducer";

export type OfflineDispatch = (action: any) => void;

/**
 * Single source of truth for the offline counters shown in the UI.
 *
 * Deliberately its own module rather than part of syncEngine: the sagas need to
 * refresh the counters after queueing a write, and importing the sync engine from
 * a saga would pull the HTTP transports (and their ESM-only dependencies) into
 * every saga's module graph.
 */
export const publishCounters = async (dispatch: OfflineDispatch): Promise<void> => {
  const rows = await listQueue();
  const pending = rows.filter((r) => r.status === "pending");
  const failed = rows.filter((r) => r.status === "failed");
  dispatch(offlineActions.setPendingAC(pending.length, failed.length));
  dispatch(
    offlineActions.setPendingKeysAC(
      pending.map((r) => r.entityKey),
      failed.map((r) => r.entityKey)
    )
  );
};
